import { PLATFORM_VALUE } from 'meinian-package/src/component/platformConfig'

export const isFun = (val) => {
  if (typeof val === 'function') {
    return true
  }
  return false
}

export const TITLE_INS_CONFIG = [
  {
    title: (dto) => `来自 #${dto.topicObjectList?.[0]?.content}`, linkUrl: (dto) => `/df/detail/topic?id=${dto.topicObjectList[0].topicId}`
  },
  {
    title: 'nickName', linkUrl: (dto) => `/cross-border/streamer-detail/info?bloggerId=${dto.bloggerId}`
  },
]

export const TITLE_CROSSBORDER_INS_CONFIG = TITLE_INS_CONFIG

export const TITLE_CONFIG = {
  [PLATFORM_VALUE.WEIBO]: { title: 'bloggerName' },
  [PLATFORM_VALUE.BRAND]: { title: 'brand', linkUrl: (dto) => `/df/detail/brand?brand=${encodeURIComponent(dto.brand)}` },
  [PLATFORM_VALUE.SHOW]: { title: 'brand' },
  [PLATFORM_VALUE.ITEM]: { title: 'shopName', linkUrl: (dto) => `/shopDetail?shopId=${dto.shopId}` },
  [PLATFORM_VALUE.UPLOAD]: { title: '上传灵感' },
  [PLATFORM_VALUE.WHOLESALE]: { title: (dto) => dto.season + dto.marketName },
  [PLATFORM_VALUE.RETAIL]: { title: (dto) => dto.season + dto.originGender + dto.brand },
  [PLATFORM_VALUE.XIAOHONGSHU]: { title: 'bloggerName', linkUrl: (dto) => `/df/detail/blogger?sourceType=5&id=${dto.bloggerId}` },
  [PLATFORM_VALUE.DY]: { title: 'shopName', linkUrl: (dto) => `/douyin/shopDetail/overview?shopId=${dto.shopId}` },
  [PLATFORM_VALUE.DY_WORKS]: { title: 'title', },
  [PLATFORM_VALUE.DW]: { title: 'brand', linkUrl: (dto) => `/df/detail/brand?brand=${encodeURIComponent(dto.brand)}` },
  [PLATFORM_VALUE.DW_GOODS]: { title: 'brand', linkUrl: (dto) => `/df/detail/brand?brand=${encodeURIComponent(dto.brand)}` },
  [PLATFORM_VALUE.JP]: { title: (dto) => `${dto.season + dto.country + dto.city}街拍`, linkUrl: (dto, cur) => `/df/detail/image?blogIds=${cur.childEntityId}&unionIds=${cur.unionId}&platformId=${cur.childPlatformId}` },
  [PLATFORM_VALUE.DHH]: { title: 'siteName' },
  [PLATFORM_VALUE.INSGOODS]: { title: 'siteName' },
  [PLATFORM_VALUE.PORTER]: { title: 'siteName' },
  [PLATFORM_VALUE.FARFETCH]: { title: 'siteName' },
  [PLATFORM_VALUE.SSENSE]: { title: 'siteName' },
  [PLATFORM_VALUE.SHOPBOP]: { title: 'siteName' },
  [PLATFORM_VALUE.XIU_CHANGE_XI_JIE]: { title: 'siteName' },
  [PLATFORM_VALUE.SHI_ZHUANG_DA_PIAN]: {
    title: (dto) => {
      if (dto?.columnName === '杂志' || dto?.columnName === '杂志大片') {
        return `${dto?.magazineName}${dto?.season}${dto?.columnName}`
      }
      return `${dto?.brand}${dto?.season}${dto?.columnName}`
    }
  },
  [PLATFORM_VALUE.CROSSBORDER]: { title: 'siteName' },
  [PLATFORM_VALUE.CROSSBORDER_INS_GOODS]: { title: 'siteName' },
  [PLATFORM_VALUE.CROSSBORDER_SHOW]: { title: 'brand' },
  [PLATFORM_VALUE.CROSSBORDER_PINTEREST]: { title: 'nickName', linkUrl: (dto) => `/cross-border/pinterest-streamer-detail/pins?pinterestUserId=${dto.userId}` },
  [PLATFORM_VALUE.TAOBAO_ZHI_DA]: { title: 'collocationTitle' },
  [PLATFORM_VALUE.ZHI_XIAO_HONG]: { title: 'nickname' },
}
